import { memo } from "react";

import GhostEnvironmentPossibleSource from "./PossibleSource";

// -----------------------------------------------------------------------------

const GhostEnvironmentPossibleSources = memo(
  function GhostEnvironmentPossibleSources() {
    return (
      <>
        <GhostEnvironmentPossibleSource />
        <GhostEnvironmentPossibleSource />
        <GhostEnvironmentPossibleSource />
        <GhostEnvironmentPossibleSource />
      </>
    );
  }
);

export default GhostEnvironmentPossibleSources;
